import './reducer';

export function getPaymentsConfig() {
    return {
        type: 'GET_PAYMENTS_CONFIG',
        promise: client => client.GET('https://api.wi-flix.com/payment-gateway/v1/config'),
    };
}
